"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NumberMysqlHandler", {
    enumerable: true,
    get: function() {
        return NumberMysqlHandler;
    }
});
const _numbergeneralhandler = require("./number.general.handler");
const _decimalmysqlhandler = require("~/db/field-handler/handlers/decimal/decimal.mysql.handler");
let NumberMysqlHandler = class NumberMysqlHandler extends _decimalmysqlhandler.DecimalMysqlHandler {
    constructor(...args){
        super(...args), this.numberGeneralHandler = new _numbergeneralhandler.NumberGeneralHandler(), this.parseUserInput = this.numberGeneralHandler.parseUserInput;
    }
};
